import { makeStyles } from '@seekube-tech/ui';

export default makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    borderRadius: 4,
    backgroundColor: theme.palette.basic.white,
  },
}));